<ion-header [translucent]="false" class="ion-no-border custom-header" mode="md">
  <ion-toolbar>
    @if (!triggerDeleteConfirmation) {
      <ion-title class="modal-title">
        {{'ACCOUNT' | translate}}
      </ion-title>
    }
    @if (triggerDeleteConfirmation) {
      <ion-title class="modal-title">
        {{'DELETE_ACCOUNT' | translate}}
      </ion-title>
    }
    
    

    <ion-buttons slot="end">
      <ion-button fill="clear" (click)="closeLogin()">
        <ion-icon slot="icon-only" name="close"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>
@if (!triggerDeleteConfirmation) {

<ion-content [fullscreen]="true" class="homepage-content">
  <div class="page-content">
    <form [formGroup]="form" (submit)="editUserDetails()">
      <div class="select-group">
        <label class="label-form-control">{{'FIRSTNAME' | translate}}</label>
        <ion-input class="bordered-input" type="text" formControlName="firstName" [readonly]="true">
        </ion-input>
      </div>
      <div class="select-group">
        <label class="label-form-control">{{'LASTNAME' | translate}}</label>
        <ion-input class="bordered-input" type="text" formControlName="lastName" [readonly]="true">
        </ion-input>
      </div>
      <div class="select-group">
        <label class="label-form-control">{{'EMAIL' | translate}}</label>
        <!-- <label class="sub-label-form-control">{{'login_page.email_format' | translate}}</label> -->
        <ion-input class="bordered-input-email" required="true" formControlName="email" [readonly]="true"
        [class.invalid]="form.get('email')?.invalid && (form.get('email')?.dirty || form.get('email')?.touched)">
          <ion-icon slot="start" name="mail-outline" aria-hidden="true" ></ion-icon>
          <ion-button fill="clear" slot="end" aria-label="Show/hide">
            <!-- <ion-icon slot="end" name="info" aria-hidden="true"></ion-icon> -->
            <ion-icon class="invalid" *ngIf="form.get('email')?.invalid && (form.get('email')?.dirty || form.get('email')?.touched)" slot="icon-only" name="information-circle-outline" aria-hidden="true"></ion-icon>
          </ion-button>
        </ion-input>
        <div class="custom-error" *ngIf="form.get('email')?.invalid && (form.get('email')?.dirty || form.get('email')?.touched)">
          <span>{{'EMAIL_FORMAT_ERROR' | translate}}</span>
        </div>
      </div>
      <div class="select-group">
        <label class="label-form-control">{{'COUNTRY' | translate}}</label>
        <ion-select formControlName="country" interface="popover" class="styled-select"
           [disabled]="true">

          <!-- Start icon -->
          <!-- <ion-icon slot="start" name="globe-outline" aria-hidden="true"></ion-icon> -->

          <!-- Options -->
          <ion-select-option
            *ngFor="let country of countries"
            [value]="country">
            {{ country.name | translate}}
          </ion-select-option>

        </ion-select>

      </div>
      <div class="select-group">
        <label class="label-form-control">{{'COMPANY' | translate}}<label class="sub-label-form-control">{{'OPTIONAL' | translate}}</label></label>
        <ion-input class="bordered-input" type="text" formControlName="company" [readonly]="true">
        </ion-input>
      </div>
      <hr>
      @if (userDetails?.sub) {
        <ion-button color="danger" fill="outline" class="not-uppercase" (click)="triggerConfirmDelete()">{{ 'DELETE_ACCOUNT' | translate}}</ion-button>
      }
      
      
      
    </form>

  </div>
</ion-content>
}
@if (triggerDeleteConfirmation) {
  <ion-content [fullscreen]="true" class="homepage-content">
    <div class="page-content">
      <ion-label style="font-size: 14px;color: #161718;">
        {{ 'DELETE_ALERT_MSG' | translate}}
      </ion-label>
    </div>
  </ion-content>
}
@if (triggerDeleteConfirmation) {
<ion-footer [translucent]="false" class="ion-no-border ">
    <!-- Button Container -->
    <div class="button-container">
      <ion-button fill="outline" class="cancel-btn" (click)="closeLogin()" expand="block">
        {{'cancel' | translate}}
      </ion-button>
      
        <ion-button color="danger" (click)="confirmDelete()" [disabled]="isDeletingAccount" expand="block">
          {{'delete' |translate}}
        </ion-button>
        <!-- <ion-button class="next-btn" (click)="validate()" [disabled]="!selectedOption" expand="block">
          {{'validate' |translate}}
        </ion-button> -->

      <!-- @else {
        <ion-button color="danger" (click)="confirmDelete()" expand="block">
          {{'delete' |translate}}
        </ion-button>
      } -->
      
    </div>
</ion-footer>
}